

export default function Partenaires() {
  return (
    <div>
      <main style={{ minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
        <h1 style={{ color: '#a020f0', fontWeight: 'bold', fontSize: '2rem' }}>Page Partenaires en maintenance</h1>
        <p style={{ color: '#555', fontSize: '1.1rem' }}>Nous travaillons actuellement sur cette page. Merci de votre compréhension.</p>
      </main>
    </div>
  );
}
